import React, { Component } from "react";
import { useLocation } from "react-router-dom";
import "./visitHistory.css";
import Page from "../../components/page/page";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";
import VisitHistory from './visitHistory';


function DeviceStatus() {

    const location = useLocation()

    return (
        <Page>
            <Header />
            <section className="container">
                <VisitHistory serial={location.state.serial } />
            </section>
            <Footer />
        </Page>
    );
}

export default DeviceStatus